<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
    <!-- A tinted band with a rule under it: the title stops floating in the same white
         as the content and the card reads as a titled panel. -->
    <div :class="cn('flex flex-col gap-y-1.5 rounded-t-xl border-b bg-muted/40 p-6', props.class)">
        <slot />
    </div>
</template>
